import React, { ReactNode, useEffect, useState } from "react";
import { createPortal } from "react-dom";

interface HeaderContentProps {
  children: ReactNode;
}

const PORTAL_ID = "wis-header-buttons-portal";

export function HeaderContentPortal() {
  return <div id={PORTAL_ID} className="flex items-center gap-4" />;
}

export const HeaderContent: React.FC<HeaderContentProps> = ({ children }) => {
  const [headerContainer, setHeaderContainer] = useState<HTMLElement | null>(
    null
  );

  useEffect(() => {
    setHeaderContainer(document.getElementById(PORTAL_ID));
  }, []);

  if (!headerContainer) return null;

  return createPortal(children, headerContainer);
};
